import { useContext, useEffect, useState } from 'react';
import { Button, Form, FormDropdown, FormGroup, FormInput, Header, Icon, Image } from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
import { htmlToText, isUndefinedOrNull, sortArrayByElement } from '../Service/Helpers';
import { getAdminData, postData, postFile, postImage } from '../Service/Request';
import { DropdownButton, Reorder, RichTextEditor, UploadImage } from './../Components';
import { LocalStorage } from './../Service/LocalStorage';

function AdminHome() {
    const [uploadedImageData, setUploadedImageData] = useState();
    const [dataToDisplay, setDataToDisplay] = useState(null);
    const [selectedValueForEdit, setSelectedValueForEdit] = useState({});
    const [btnReset, setBtnReset] = useState('');
    const [reset, setReset] = useState(false);
    const [description, setDescription] = useState('');
    const [cardsList, setCardsList] = useState([]);
    const [dropdownList, setDropdownList] = useState([]);
    const [navigationOptions, setNavigationOptions] = useState([]);
    const [selectedNavigation, setSelectedNavigation] = useState({});
    const { navigationList: [navigationList] } = useContext(LocalStorage);
    const [category, setCategory] = useState('');
    const [operation, setOperation] = useState('');
    const [fileData, setFileData] = useState();
    const [headerCharCount, setHeaderCharCount] = useState(0);
    const { token: [token, setToken] } = useContext(LocalStorage);
    const { isLoaderActive: [, setIsLoaderActive] } = useContext(LocalStorage);
    const [yearsList, setYearsList] = useState([]);
    const [selectedYear, setSelectedYear] = useState({});

    useEffect(() => {
        setNavigationOptions(navigationList.map(x => { return { key: x.displayText, text: x.displayText, value: x.displayText } }));
        loadData();
    }, []);

    const loadData = () => {
        let body = {
            token: token
        }
        setIsLoaderActive(true);
        getAdminData('adminHome', body).then(homeRes => {
            if (!isUndefinedOrNull(homeRes)) {
                setDataToDisplay(homeRes);
                let years = Array.from({ length: new Date().getFullYear() - 2010 + 1 }, (value, index) => 2010 + index).map(x => {
                    return { key: x, text: x, value: x }
                }).reverse();
                setYearsList(years);
                resetAll();
                setOperation('');
                setCategory('');
                setIsLoaderActive(false);
            }
            else {
                setToken(null);
            }
        });
    }

    const onBtnClick = (op, cat) => {
        setOperation(op);
        setCategory(cat);
        resetAll();
        if (cat === 'Card') {
            setCardsList(sortArrayByElement(dataToDisplay.cardList, 'order').map(x => {
                return {
                    key: x.id,
                    text: x.header,
                    value: x.id
                }
            }));
        }
        else if (cat === 'Annual report') {
            setDropdownList(dataToDisplay.annualReport.map(x => {
                return {
                    key: x.id,
                    text: x.year + ' (' + x.doc + ')',
                    value: x.id
                }
            }));
        }
        else if (cat === 'Projects handled') {
            setDropdownList(dataToDisplay.projectsHandled.map(x => {
                return {
                    key: x.id,
                    text: htmlToText(x.title),
                    value: x.id
                }
            }));
        }
    }

    const getDisplayText = (navLink) => {
        let navDetail = navigationList.find(x => x.to === navLink);
        if (!isUndefinedOrNull(navDetail)) {
            return navDetail.displayText;
        }
        else {
            let returnVal = '';
            navigationList.forEach(x => {
                if (!isUndefinedOrNull(x.sub)) {
                    let subNavDetail = x.sub.find(x => x.to === navLink);
                    if (!isUndefinedOrNull(subNavDetail)) {
                        returnVal = x.displayText;
                    }
                }
            });
            return returnVal;
        }
    }

    const getlink = (displayText) => {
        let navDetail = navigationList.find(x => x.displayText === displayText);
        if (!isUndefinedOrNull(navDetail.to)) {
            return navDetail.to;
        }
        else {
            return navDetail.sub[0].to;
        }
    }

    const onDropdownSelection = (val) => {
        if (val !== '') {
            if (category === 'Card') {
                let editVal = dataToDisplay.cardList.find(x => x.id === val);
                setSelectedValueForEdit(editVal);
                setSelectedNavigation(getDisplayText(editVal?.navigateTo));
                setDescription(editVal?.description);
                setHeaderCharCount(editVal.header.length);
                setReset(false);
            }
            else if (category === 'Annual report') {
                setSelectedValueForEdit(dataToDisplay.annualReport.find(x => x.id === val));
            }
            else if (category === 'Projects handled') {
                setSelectedValueForEdit(dataToDisplay.projectsHandled.find(x => x.id === val));
            }
        }
        else {
            setSelectedValueForEdit({});
            setSelectedNavigation('');
            setHeaderCharCount(0);
        }
        document.getElementById('inputForm')?.reset();
    }

    const onSave = (data = null) => {
        setIsLoaderActive(true);
        if (operation === 'add') {
            if (category === 'Annual Report') {
                if (!isUndefinedOrNull(selectedYear) && !isUndefinedOrNull(fileData)) {
                    let formData = new FormData();
                    formData.append('file', fileData, fileData.name);
                    formData.append('token', token);
                    postFile(formData).then(postFileRes => {
                        if (!isUndefinedOrNull(postFileRes)) {
                            let body = {
                                token: token,
                                operation: operation,
                                category: 'annualReport',
                                data: {
                                    id: uuidv4(),
                                    doc: postFileRes.file,
                                    year: selectedYear.value
                                }
                            }
                            postData('postHome', body).then(postHomeRes => {
                                if (!isUndefinedOrNull(postHomeRes)) {
                                    alert('Successfully submitted.');
                                    loadData();
                                }
                                else {
                                    setToken(null);
                                }
                            });
                        }
                        else {
                            setToken(null);
                        }
                    });
                }
                else {
                    setIsLoaderActive(false);
                    alert('Fill all the required fields.');
                }
            }
            else if (category === 'Projects handled') {
                if (!isUndefinedOrNull(htmlToText(description))) {
                    let body = {
                        token: token,
                        category: 'projectsHandled',
                        operation: operation,
                        data: {
                            title: description,
                            order: dataToDisplay['projectsHandled'].length + 1,
                            id: uuidv4()
                        }
                    }
                    postData('postHome', body).then(postHomeRes => {
                        if (!isUndefinedOrNull(postHomeRes)) {
                            alert('Successfully submitted.');
                            loadData();
                        }
                        else {
                            setToken(null);
                        }
                    });
                }
                else {
                    setIsLoaderActive(false);
                    alert('Fill all the required fields.');
                }
            }
        }
        else if (operation === 'edit') {
            if (category === 'Image') {
                if (!isUndefinedOrNull(uploadedImageData)) {
                    let delBody = {
                        token: token,
                        image: [dataToDisplay.banner]
                    }
                    postData('deleteImage', delBody).then(postDelImgRes => {
                        if (!isUndefinedOrNull(postDelImgRes)) {
                            let formData = new FormData();
                            formData.append('image', uploadedImageData, uploadedImageData.name);
                            formData.append('token', token);
                            postImage(formData).then(postImgRes => {
                                if (!isUndefinedOrNull(postImgRes)) {
                                    let body = {
                                        token: token,
                                        category: category,
                                        operation: operation,
                                        data: {
                                            banner: postImgRes.image
                                        }
                                    }
                                    postData('postHome', body).then(postHomeRes => {
                                        if (!isUndefinedOrNull(postHomeRes)) {
                                            alert('Successfully submitted.');
                                            loadData();
                                        }
                                        else {
                                            setToken(null);
                                        }
                                    });
                                }
                                else {
                                    setToken(null);
                                }
                            });
                        }
                        else {
                            setToken(null);
                        }
                    });
                }
                else {
                    setIsLoaderActive(false);
                    alert('Fill all the required fields.');
                }
            }
            else if (category === 'Card') {
                let headerText = document.getElementById('headerText')?.value;
                let des = htmlToText(description);
                if (!isUndefinedOrNull(headerText) && !isUndefinedOrNull(selectedNavigation) && !isUndefinedOrNull(des)) {
                    if (selectedValueForEdit.header !== headerText || selectedValueForEdit.navigateTo !== getlink(selectedNavigation) || selectedValueForEdit.description !== description || !isUndefinedOrNull(uploadedImageData)) {
                        if (des.length > 200 || headerText.length > 30) {
                            setIsLoaderActive(false);
                            alert('You exceed the maximum length in the input field.');
                        }
                        else {
                            let body = {
                                token: token,
                                category: category,
                                operation: operation,
                                data: {
                                    image: selectedValueForEdit.image,
                                    header: headerText,
                                    navigateTo: getlink(selectedNavigation),
                                    description: description,
                                    order: selectedValueForEdit.order,
                                    id: selectedValueForEdit.id
                                }
                            }
                            if (isUndefinedOrNull(uploadedImageData)) {
                                postData('postHome', body).then(postHomeRes => {
                                    if (!isUndefinedOrNull(postHomeRes)) {
                                        alert('Successfully submitted.');
                                        loadData();
                                    }
                                    else {
                                        setToken(null);
                                    }
                                });
                            }
                            else {
                                let delBody = {
                                    token: token,
                                    image: [selectedValueForEdit.image]
                                }
                                postData('deleteImage', delBody).then(postDelImgRes => {
                                    if (!isUndefinedOrNull(postDelImgRes)) {
                                        let formData = new FormData();
                                        formData.append('image', uploadedImageData, uploadedImageData.name);
                                        formData.append('token', token);
                                        postImage(formData).then(postImgRes => {
                                            if (!isUndefinedOrNull(postImgRes)) {
                                                body.data['image'] = postImgRes.image;
                                                postData('postHome', body).then(postHomeRes => {
                                                    if (!isUndefinedOrNull(postHomeRes)) {
                                                        alert('Successfully submitted.');
                                                        loadData();
                                                    }
                                                    else {
                                                        setToken(null);
                                                    }
                                                });
                                            }
                                            else {
                                                setToken(null);
                                            }
                                        });
                                    }
                                    else {
                                        setToken(null);
                                    }
                                });
                            }
                        }
                    }
                    else {
                        setIsLoaderActive(false);
                        alert('No changes made to submit.');
                    }
                }
                else {
                    setIsLoaderActive(false);
                    alert('Fill all the required fields.');
                }
            }
            else if (category === 'Projects handled') {
                if (!isUndefinedOrNull(htmlToText(description))) {
                    if (selectedValueForEdit.description !== description) {
                        let body = {
                            token: token,
                            category: category,
                            operation: operation,
                            data: {
                                title: description,
                                order: selectedValueForEdit.order,
                                id: selectedValueForEdit.id
                            }
                        }
                        postData('postHome', body).then(postHomeRes => {
                            if (!isUndefinedOrNull(postHomeRes)) {
                                alert('Successfully submitted.');
                                loadData();
                            }
                            else {
                                setToken(null);
                            }
                        });
                    }
                    else {
                        setIsLoaderActive(false);
                        alert('No changes made to submit.');
                    }
                }
                else {
                    setIsLoaderActive(false);
                    alert('Fill all the required fields.');
                }
            }
        }
        else if (operation === 'delete') {
            if (category === 'Annual report') {
                let delBody = {
                    token: token,
                    file: selectedValueForEdit.doc
                }
                postData('deleteFile', delBody).then(postDelFileRes => {
                    if (!isUndefinedOrNull(postDelFileRes)) {
                        let body = {
                            token: token,
                            operation: operation,
                            category: 'annualReport',
                            data: {
                                id: selectedValueForEdit.id
                            }
                        }
                        postData('postHome', body).then(postHomeRes => {
                            if (!isUndefinedOrNull(postHomeRes)) {
                                alert('Successfully submitted.');
                                loadData();
                            }
                            else {
                                setToken(null);
                            }
                        });
                    }
                    else {
                        setToken(null);
                    }
                });
            }
            else if (category === 'Projects handled') {
                let body = {
                    token: token,
                    category: 'projectsHandled',
                    operation: operation,
                    data: {
                        id: selectedValueForEdit.id
                    }
                }
                postData('postHome', body).then(postHomeRes => {
                    if (!isUndefinedOrNull(postHomeRes)) {
                        alert('Successfully submitted.');
                        loadData();
                    }
                    else {
                        setToken(null);
                    }
                });
            }
        }
        else if (operation === 'order') {
            if (isUndefinedOrNull(data.find(x => x.newOrder === 0))) {
                let changedOrder = data.filter(x => x.newOrder !== x.order).map(y => { return { id: y.id, order: y.newOrder } });
                if (!isUndefinedOrNull(changedOrder)) {
                    let cat = category === 'Card' ? 'cardlist' : 'projectsHandled';
                    let newOrderedData = [];
                    changedOrder.forEach(x => {
                        let orderedData = dataToDisplay[cat].find(y => y.id === x.id);
                        orderedData.order = x.order;
                        newOrderedData.push(orderedData);
                    });
                    let body = {
                        token: token,
                        operation: operation,
                        category: cat,
                        data: newOrderedData
                    }
                    postData('postHome', body).then(postHomeRes => {
                        if (!isUndefinedOrNull(postHomeRes)) {
                            alert('Successfully submitted.');
                            loadData();
                        }
                        else {
                            setToken(null);
                        }
                    });
                }
                else {
                    setIsLoaderActive(false);
                    alert('No changes made to submit.');
                }
            }
            else {
                setIsLoaderActive(false);
                alert('Some data with no order, please fill that to save');
            }
        }
    }

    const resetAll = () => {
        setSelectedValueForEdit({});
        setBtnReset('');
        setFileData(null);
        setSelectedYear({});
        setUploadedImageData(null);
        if (document.getElementById('search') !== null) {
            document.getElementById('search').value = '';
        }
        let charCount = document.getElementById('headerText')?.value.length;
        setHeaderCharCount(isUndefinedOrNull(charCount) ? 0 : charCount);
        setReset(true);
    }

    const onYearSelection = (value) => {
        if (value === '') {
            setSelectedYear({});
        }
        else {
            setSelectedYear({ value: value });
        }
    }

    const onRemoveFile = () => {
        setFileData(null);
        document.getElementById('file').value = '';
    }

    const onNavigationSelection = (value) => {
        if (value !== '') {
            setSelectedNavigation(value);
        }
        else {
            setSelectedNavigation('');
        }
    }

    return (
        <>
            {!isUndefinedOrNull(dataToDisplay) &&
                <div>
                    <div className='buttonsGroup'>
                        <DropdownButton btnReset={btnReset} onChange={(op, cat) => onBtnClick(op, cat)} page='home' btn='add' />
                        <DropdownButton btnReset={btnReset} onChange={(op, cat) => onBtnClick(op, cat)} page='home' btn='edit' />
                        <DropdownButton btnReset={btnReset} onChange={(op, cat) => onBtnClick(op, cat)} page='home' btn='delete' />
                        <DropdownButton btnReset={btnReset} onChange={(op, cat) => onBtnClick(op, cat)} page='home' btn='order' />
                    </div>
                    <div>
                        <div className='editContainer'>
                            <Header as='h2'>
                                {operation.toUpperCase() + ' ' + category.toUpperCase()}
                            </Header>
                            {operation === 'add' &&
                                <>
                                    <Form className='adminInputContainer' id='inputForm' autocomplete='off'>
                                        {category !== 'Projects handled' &&
                                            <>
                                                <FormDropdown
                                                    placeholder='Select year' label='Year' className='adminInput'
                                                    fluid selection closeOnChange closeOnEscape closeOnBlur required clearable search
                                                    options={yearsList} selectOnBlur={false} upward={false}
                                                    onChange={(event, data) => onYearSelection(data.value)}
                                                    disabled={isUndefinedOrNull(yearsList) || yearsList.length === 0} />
                                                <FormInput fluid label='Upload file' id='file' type='file' onChange={(event) => setFileData(event.target.files[0])} className='adminInput' required />
                                                {!isUndefinedOrNull(fileData) &&
                                                    <>
                                                        <div className='filePreview'>
                                                            <a href={URL.createObjectURL(fileData)} target='_blank' rel='noreferrer'>{fileData.name}</a>
                                                            <Icon className='fileCloseIcon' name='remove circle' size='large' color='red' onClick={() => onRemoveFile()} />
                                                        </div>
                                                    </>
                                                }
                                            </>
                                        }
                                        {(category === 'Projects handled') &&
                                            <>
                                                <RichTextEditor data={''} id='title' placeholder={'Type the projects handled here...'} label={category} onChange={(value) => { setDescription(value); setReset(false); }} reset={reset} required={true} />
                                            </>
                                        }
                                    </Form>
                                    <Button icon='save' labelPosition='left' content='Save' color='green' className='saveBtn' onClick={() => onSave()} />
                                </>
                            }
                            {operation === 'edit' &&
                                <>
                                    {category === 'Image' &&
                                        <>
                                            <Form className='adminInputContainer' id='inputForm' autocomplete='off'>
                                                <UploadImage imageData={(val) => { setUploadedImageData(val); setReset(false); }} isRequired={true} reset={reset} />
                                                {isUndefinedOrNull(uploadedImageData) &&
                                                    <>
                                                        <Image src={dataToDisplay.banner} className='imagePreview' />
                                                    </>
                                                }
                                            </Form>
                                            <Button icon='save' labelPosition='left' content='Save' color='green' className='saveBtn' onClick={() => onSave()} />
                                        </>
                                    }
                                    {category === 'Card' &&
                                        <>
                                            <Form className='adminInputContainer' autocomplete='off'>
                                                <FormDropdown
                                                    placeholder='Select a card' label='Card' className='adminInput'
                                                    fluid selection closeOnChange closeOnEscape closeOnBlur clearable search required
                                                    options={cardsList} selectOnBlur={false} upward={false} width='16'
                                                    onChange={(event, data) => onDropdownSelection(data.value)}
                                                    disabled={isUndefinedOrNull(cardsList) || cardsList.length === 0} />
                                            </Form>
                                            {!isUndefinedOrNull(selectedValueForEdit) &&
                                                <>
                                                    <Form className='adminInputContainer adminForm' id='inputForm' autocomplete='off'>
                                                        <FormGroup widths='equal'>
                                                            <div>
                                                                <FormInput fluid label='Header' id='headerText' type='text' placeholder='Enter header' className='adminInput' width='16' onChange={() => setHeaderCharCount(document.getElementById('headerText')?.value.length)} defaultValue={selectedValueForEdit.header} required />
                                                                <div className='m-75'><b><small className={headerCharCount > 30 ? 'redFont' : ''}>{headerCharCount}</small><small>/30</small></b></div>
                                                            </div>
                                                            <FormDropdown
                                                                placeholder='Select main navigation' label='Navigation' className='adminInput navSubNav'
                                                                fluid selection closeOnChange closeOnEscape closeOnBlur clearable search required
                                                                value={!isUndefinedOrNull(selectedNavigation) ? selectedNavigation : null}
                                                                options={navigationOptions} selectOnBlur={false} upward={false}
                                                                onChange={(event, data) => onNavigationSelection(data.value, false)}
                                                                disabled={isUndefinedOrNull(navigationOptions) || navigationOptions.length === 0} />
                                                        </FormGroup>
                                                        <div>
                                                            <RichTextEditor data={!isUndefinedOrNull(selectedValueForEdit) ? selectedValueForEdit.description : ''} id='cardDescription' placeholder='Enter card description...' label='Description' onChange={(value) => { setDescription(value); setReset(false); }} reset={reset} required={true} />
                                                            <div className='m-75'><b><small className={htmlToText(description).length > 200 ? 'redFont' : ''}>{htmlToText(description).length}</small><small>/200</small></b></div>
                                                        </div>
                                                        <UploadImage imageData={(val) => { setUploadedImageData(val); setReset(false); }} required={false} reset={reset} isEdit={operation === 'edit'} />
                                                        {isUndefinedOrNull(uploadedImageData) &&
                                                            <>
                                                                <Image src={selectedValueForEdit.image} className='imagePreview' />
                                                            </>
                                                        }
                                                    </Form>
                                                    <Button icon='save' labelPosition='left' content='Save' color='green' className='saveBtn' onClick={() => onSave()} />
                                                </>
                                            }
                                        </>
                                    }
                                    {category === 'Projects handled' &&
                                        <>
                                            <Form className='adminInputContainer' autocomplete='off'>
                                                <FormDropdown
                                                    placeholder={'Select ' + category.toLowerCase()} label={category}
                                                    className='adminInput' fluid selection closeOnChange closeOnEscape closeOnBlur clearable search required
                                                    options={dropdownList} selectOnBlur={false} upward={false} width='16'
                                                    onChange={(event, data) => onDropdownSelection(data.value)}
                                                    disabled={isUndefinedOrNull(dropdownList) || dropdownList.length === 0} />
                                            </Form>
                                            {!isUndefinedOrNull(selectedValueForEdit) &&
                                                <>
                                                    <Form className='adminInputContainer' id='inputForm' autocomplete='off'>
                                                        <RichTextEditor data={!isUndefinedOrNull(selectedValueForEdit) ? selectedValueForEdit.title : ''} id='title' placeholder={'Type the ' + category.toLowerCase() + ' here...'} label={category} onChange={(value) => { setDescription(value); setReset(false); }} reset={reset} required={true} />
                                                    </Form>
                                                    <Button icon='save' labelPosition='left' content='Save' color='green' className='saveBtn' onClick={() => onSave()} />
                                                </>
                                            }
                                        </>
                                    }

                                </>
                            }
                            {operation === 'delete' &&
                                <>
                                    <Form className='adminInputContainer' autocomplete='off'>
                                        <FormDropdown
                                            placeholder={'Select ' + category.toLowerCase()} label={category} className='adminInput'
                                            fluid selection closeOnChange closeOnEscape closeOnBlur clearable search required
                                            options={dropdownList} selectOnBlur={false} upward={false} width='16'
                                            onChange={(event, data) => onDropdownSelection(data.value)}
                                            disabled={isUndefinedOrNull(dropdownList) || dropdownList.length === 0} />
                                    </Form>
                                    {!isUndefinedOrNull(selectedValueForEdit) &&
                                        <>
                                            {category !== 'Projects handled' &&
                                                <div>
                                                    <b>File: </b><a href={selectedValueForEdit.doc} download={selectedValueForEdit.doc}><u>{selectedValueForEdit.year + ' (' + selectedValueForEdit.doc + ')'}</u></a>
                                                </div>
                                            }
                                            {category === 'Projects handled' &&
                                                <div dangerouslySetInnerHTML={{ __html: selectedValueForEdit.title }}></div>
                                            }
                                            <Button icon='trash' labelPosition='left' content='Delete' className='deleteBtn' color='red' onClick={() => onSave()} />
                                        </>
                                    }
                                </>
                            }
                            {operation === 'order' &&
                                <>
                                    <Reorder dataToBeOrdered={category === 'Card' ? dataToDisplay.cardList : dataToDisplay.projectsHandled} reset={reset} onSaveClick={(data) => { onSave(data); setReset(false); }} />
                                </>
                            }
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

export default AdminHome;